import dynamic from "next/dynamic";
import client from "../src/apollo-client";
import { useQuery } from '@apollo/client';
import {GET_PAGE_SLUGS} from "../src/queries/pages/get-pages"
import {GET_POST_SLUGS} from "../src/queries/posts/get-posts"

import {
  getPostBySlug,
  getPostSlugs,
  getMenus,
} from "../src/lib/dataFetch";

const PostTemplate = dynamic(() => import("../src/templates/PostTemplate"));
const PageTemplate = dynamic(() => import("../src/templates/PageTemplate"));

export default function Post({ post, menus, author, contentType }) {
  return (
  <>
  {contentType === "post" && <PostTemplate post={post} menus={menus} author={author} />}
  {contentType === "page" && <PageTemplate post={post} menus={menus} />}
  </>);
}

export async function getStaticProps(context) {
  const { data } = await getPostBySlug(context.params.slug);
  const {post, author} = data
  const contentType = post.contentType.node.name
  const menus = await getMenus();
  return {
    props: {
      post,
      author,
      menus,
      contentType,
    },
  };
}

export async function getStaticPaths() {
  const posts = await getPostSlugs();
  const pageData = await client.query({
    query: GET_PAGE_SLUGS
  })
  
  const {nodes: pages} = pageData.data.pages
  
  let paths = posts.map((post) => ({
    params: { slug: post.slug },
  }));
  pages.map((page) => (
    paths = paths.concat({params: { slug: page.slug },})
  ))

  return { paths, fallback: false };
}
